import React, { useEffect, useState } from 'react'
import { Box, ClickAwayListener, Popper } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { toast } from 'react-toastify'
import styled from 'styled-components'

import { useAction } from '@/hooks/useAction'
import { useTableData } from '@/hooks/useTableData'

import CustomView from '../CustomView'
import CustomGraphy from '../CustomGraphy'
import { applyRedStyle } from '@/utils'

const ActionsButton = styled.button`
  background-color: #d0d4dd;
  width: 20px;
  height: 20px;
  border: transparent;
  border-radius: 2px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
`
const ActionList = styled(Box)`
  font-size: 14px;
  min-width: 160px;
`
// Acima do cabeçalho sticky da tabela (999) e do backdrop de modais da MUI (1300)
const ACTION_LIST_Z_INDEX = 1301
const ActionRow = styled(CustomGraphy)`
  width: 100%;
  padding: 10px 16px;
  cursor: pointer;

  &:hover {
    background: #f3f4f6;
  }

  &.disabled {
    display: none;
  }
`

interface IActions {
  actions: string[]
  data: any
  handleAction?: (action: string, rowData?: any) => void
  overrideAction?: boolean
  allowEditInactive?: boolean
  openUpward?: boolean
}

function Actions({
  actions,
  data,
  handleAction,
  overrideAction,
  allowEditInactive = false,
  openUpward = false
}: IActions) {
  const { ACTION_ID, SET_ACTION_NAME, updateValue } = useAction()
  const { SET_ROW_DATA } = useTableData()
  const [OPEN_ACTION, SET_OPEN_ACTION] = useState(false)
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  function actionIncludeID() {
    updateValue(data.id)
  }

  function handleClickAway(event: MouseEvent | TouchEvent) {
    if (anchorEl && anchorEl.contains(event.target as Node)) return
    updateValue('')
  }

  function activateAllowed(item: string, reactivate: boolean) {
    if (data.situation === 'Ativo' || data.situation === true) return true

    return item === 'Inativar' && !reactivate ? false : true
  }

  function handleClickOnActions(item: string, reactivate: boolean) {
    if (!activateAllowed(item, data.reactivate)) {
      return toast.warning('Não é possível reativar.')
    }

    handleAction?.(item, data)
    if (!overrideAction) SET_ACTION_NAME(item)
    SET_ROW_DATA(data)
    updateValue('')
  }

  useEffect(() => {
    if (ACTION_ID === data.id) return SET_OPEN_ACTION(true)
    SET_OPEN_ACTION(false)
  }, [ACTION_ID])

  function renderActionLabel(action: string) {
    const isInactive = data.situation === 'Inativo' || data.situation === false

    if (action === 'Inativar' && isInactive) return 'Ativar'

    if (action === 'Inativar' || action === 'Excluir') {
      return applyRedStyle(action)
    }

    return action
  }

  return (
    <>
      <ActionsButton ref={setAnchorEl} onClick={actionIncludeID}>
        <MoreVertIcon />
      </ActionsButton>

      <Popper
        open={OPEN_ACTION && !!anchorEl}
        anchorEl={anchorEl}
        placement={openUpward ? 'top-start' : 'bottom-start'}
        modifiers={[
          { name: 'offset', options: { offset: [0, 4] } },
          {
            name: 'flip',
            options: {
              fallbackPlacements: ['bottom-start', 'top-start'],
              padding: 8
            }
          },
          { name: 'preventOverflow', options: { altAxis: true, padding: 8 } }
        ]}
        sx={{ zIndex: ACTION_LIST_Z_INDEX }}
      >
        <ClickAwayListener onClickAway={handleClickAway}>
          <ActionList>
            <CustomView
              backColor="white"
              sx={{
                boxShadow:
                  '0px 2px 1px -3px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 0%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
                borderRadius: '4px',
                py: '6px'
              }}
            >
              {actions.map((item: string) => (
                <ActionRow
                  key={item}
                  className={
                    item === 'Editar' &&
                    !allowEditInactive &&
                    (data.situation === 'Inativo' || data.situation === false)
                      ? 'disabled'
                      : activateAllowed(item, data.reactivate)
                        ? ''
                        : 'disabled'
                  }
                  onClick={() => handleClickOnActions(item, data.reactivate)}
                >
                  {renderActionLabel(item)}
                </ActionRow>
              ))}
            </CustomView>
          </ActionList>
        </ClickAwayListener>
      </Popper>
    </>
  )
}

export default Actions
